/**
 * The Layout3 Config object.
 */
const Layout3Config = {
  title: 'Minimalist',
  defaults: {
    mode: 'container',
    containerWidth: 1120,
    scroll: 'content',
    navbar: {
      display: false,
      style: 'fixed',
      folded: true
    },
    toolbar: {
      display: true,
      style: 'static',
      position: 'below'
    },
    leftSidePanel: {
      display: true
    },
    rightSidePanel: {
      display: false
    }
  },
  form: {
    navbar: {
      type: 'group',
      title: 'Navbar',
      children: {
        display: {
          title: 'Display',
          type: 'switch'
        }
      }
    },
    toolbar: {
      type: 'group',
      title: 'Toolbar',
      children: {
        display: {
          title: 'Display',
          type: 'switch'
        },
        position: {
          title: 'Position',
          type: 'radio',
          options: [
            {
              name: 'Above',
              value: 'above'
            },
            {
              name: 'Below',
              value: 'below'
            }
          ]
        }
      }
    }
  }
};

export type Layout3ConfigDefaultsType = (typeof Layout3Config)['defaults'];

export default Layout3Config;
